import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDWizardSubtitle } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper/Layout/FDWizardSubtitle';
import { HeadlineTextSmall } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextSmall,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDWizardSubtitle,
  }, overrideReadOnly);
